// extracted by mini-css-extract-plugin
export var orderSummary = "_q9-0";
export var showMoreLessButton = "_q9-1";